import { createTypes } from 'redux-action-creator';
import { parseJSON, handleNetworkError, getCookie } from '../../utils'


export const casesTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'CASES');
export const caseDetailTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'CASE_DETAIL');
export const caseAnnotationTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'CASE_ANNOTATION');
export const caseResolveTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'CASE_RESOLVE');
export const clearCaseResolveResponseType = 'CLEAR_CASE_RESOLVE_RESPONSE';
export const setAgentCasesFiltersType = 'SET_AGENT_CASES_FILTERS';


export const requestCases = () => {
    return {
        type: casesTypes.REQUEST,
    };
};

export const receiveCases = (response) => {
    return {
        type: casesTypes.RECEIVE,
        data: response,
    };
};

export const receiveCasesError = (response) => {
    return {
        type: casesTypes.ERROR,
        response: response,
    };
};

export const requestCaseDetails = () => {
    return {
        type: caseDetailTypes.REQUEST,
    };
};

export const receiveCaseDetails = (response) => {
    return {
        type: caseDetailTypes.RECEIVE,
        data: response,
    };
};

export const receiveCaseDetailsError = (response) => {
    return {
        type: caseDetailTypes.ERROR,
        response: response,
    };
};

export const requestCaseAnnotation = () => {
    return {
        type: caseAnnotationTypes.REQUEST,
    };
};

export const receiveCaseAnnotation = (response, payload = {}) => {
    return {
        type: caseAnnotationTypes.RECEIVE,
        data: response,
        payload,
    };
};

export const receiveCaseAnnotationError = (response) => {
    return {
        type: caseAnnotationTypes.ERROR,
        response: response,
    };
};

export const requestCaseResolve = () => {
    return {
        type: caseResolveTypes.REQUEST,
    };
};

export const receiveCaseResolve = (response, payload = {}) => {
    return {
        type: caseResolveTypes.RECEIVE,
        data: response,
        payload,
    };
};

export const receiveCaseResolveError = (response) => {
    return {
        type: caseResolveTypes.ERROR,
        response: response,
    };
};

export const clearCaseResolveResponse = () => {
    return {
        type: clearCaseResolveResponseType,
    };
};

export const setAgentCasesFilters = (filters = {}) => {
    return {
        type: setAgentCasesFiltersType,
        filters,
    };
};


export const fetchCases = () => {
    return dispatch => {
        let apiUrl = `/api/v1/cases/`
        let success = true

        dispatch(requestCases());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'GET',
            credentials: 'include',
        })
        .then(response => {
            if (response.status >= 400) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveCases(response));
            } else {
                dispatch(receiveCasesError(response))
            }
            return response
        })
        .catch(handleNetworkError);
    };
};


export const fetchCaseDetail = (caseId) => {
    return dispatch => {
        let apiUrl = `/api/v1/cases/case-details/${caseId}`
        let success = true

        dispatch(requestCaseDetails());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'GET',
            credentials: 'include',
        })
        .then(response => {
            if (response.status >= 400) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveCaseDetails(response));
            } else {
                dispatch(receiveCaseDetailsError(response))
            }
            return response
        })
        .catch(handleNetworkError);
    };    
}

export const postCaseAnnotation = (caseId, subject, description, advisorName, attachedFiles) => {
    return dispatch => {
        const apiUrl = `/api/v1/cases/case-details/${caseId}/annotations/`
        let success = true

        dispatch(requestCaseAnnotation());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        const payload = {
            subject,
            description,
            advisorName
        }

        if (attachedFiles && attachedFiles.length) {
            let fileNameMsg = '';
            payload.attachedFiles = attachedFiles.map((file) => { 
                fileNameMsg += file.name+"; "; 
                return {
                    data: file.base64,
                    type: file.type,
                    title: file.name,
                 }
            });
            payload.description = payload.description+"\r\nHengdi við skrá(r):"+fileNameMsg.substring(0,fileNameMsg.length-2);
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(payload),
            credentials: 'include',
        })
        .then(response => {
            if (response.status >= 400) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveCaseAnnotation(response, payload));
            } else {
                dispatch(receiveCaseAnnotationError(response))
            }
            return response
        })
        .catch(handleNetworkError);
    };
}

export const postCaseResolve = (caseId, advisorCode, terminationDecision = null, terminationComment) => {
    return dispatch => {
        const apiUrl = `/api/v1/cases/case-details/${caseId}/resolve/`
        let success = true

        dispatch(requestCaseResolve());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        const payload = {
            advisor_code: advisorCode,
            termination_decision: terminationDecision,
            termination_comment: terminationComment
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(payload),
            credentials: 'include',
        })
        .then(response => {
            if (response.status >= 400) {
                success = false
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveCaseResolve(response, payload));
            } else {
                dispatch(receiveCaseResolveError(response))
            }
            return response
        })
        .catch(handleNetworkError);
    };
}
